import React from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export function ListNewButton({
  onClick,
  label = "Nuevo",
  disabled,
  className,
}: {
  onClick: () => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <TooltipProvider delayDuration={400}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex">
            <Button
              type="button"
              variant="default"
              size="icon"
              disabled={disabled}
              aria-label={label}
              title={label}
              onClick={onClick}
              className={cn("h-9 w-9", className)}
            >
              <Plus className="h-4 w-4" />
            </Button>
          </span>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

/** Barra de listado: búsqueda a la izquierda, «+» (Nuevo) pegado a la derecha. */
export function ListToolbar({
  children,
  onNew,
  extra,
}: {
  children: React.ReactNode;
  onNew?: () => void;
  extra?: React.ReactNode;
}) {
  return (
    <div className="flex items-end gap-2">
      <div className="min-w-0 max-w-md flex-1">{children}</div>
      {extra}
      {onNew ? (
        <div className="ml-auto shrink-0">
          <ListNewButton onClick={onNew} />
        </div>
      ) : null}
    </div>
  );
}

export function ListNewLoading({
  onNew,
  message,
}: {
  onNew?: () => void;
  message: string;
}) {
  return (
    <div className="space-y-4 mt-4">
      {onNew ? (
        <div className="flex justify-end">
          <ListNewButton onClick={onNew} />
        </div>
      ) : null}
      <div className="p-8 text-center text-muted-foreground">{message}</div>
    </div>
  );
}
